/** An empty/malformed response is not evidence that a financial check passed. */
export function vatDetectionStatus(detection) {
    if (!detection || detection.success === false || detection.catalog_available === false
        || detection.status === 'unavailable') return 'unavailable';
    if (!Array.isArray(detection.accounts)) return 'unavailable';
    if (detection.accounts.length > 0) return 'action_required';
    if (Number(detection.blocking) > 0 || detection.status === 'action_required') return 'unavailable';
    if (detection.status === 'passed' || (detection.catalog_available === true && detection.blocking === 0)) return 'passed';
    return 'unavailable';
}
